<template>
    <div>
        <div v-if="this.path.length > 0">
            <div>
                {{ this.path }}
            </div>
            <button @click="backButtonClickEventHandler">back</button>
        </div>
        <div>
            <apexchart ref="chart" type="bar" :options="chartOptions" @dataPointSelection="dataPointSelectionEventHandler"
                :series="series">
                </apexchart>
        </div>
    </div>
</template>

<script>

import VueApexCharts from "vue-apexcharts";
import { DashboardService } from './services'
const dataPointSelectionEventHandler = function (event, chartContext, config) {
    this.navigate(config.dataPointIndex);
}

const backButtonClickEventHandler = function () {
    this.navigateBack();
}

const getCurrentChartData = function () {
    var data = this.chartData;

    this.path.forEach(selection => {
        data = data.childrenCharts[selection.index]
    });

    return data;
}






const refreshChart = function() {
  var data = this.getCurrentChartData()
  this.$refs.chart.updateSeries(data.series);

  this.$refs.chart.updateOptions({
      xaxis: {
        categories: data.categories
      }
  });

}

const navigate = function (index) {
    var data = this.getCurrentChartData();

    if (data.childrenCharts.length > 0) {
        this.path.push({
            name: data.categories[index],
            index: index
        });
    }

    this.refreshChart();
}

const navigateBack = function () {
    if (this.path.length > 0) {
        this.path.pop();
        this.refreshChart();
    }
}

const setChartData = function (data) {
    this.chartData = data;

    this.refreshChart();
}

export default {
    name: 'AdvancedChart',
    components: {
        apexchart: VueApexCharts
    },
    props: [],
    methods: {
        getCurrentChartData,
        refreshChart,
        navigate,
        navigateBack,
        setChartData,
        dataPointSelectionEventHandler,
        backButtonClickEventHandler
    },
    data: function () {
        return {
            chartOptions: {
                chart: {
                    animations: {
                        enabled: true,
                        easing: 'easeinout',
                        speed: 800,
                        animateGradually: {
                            enabled: true,
                            delay: 150
                        },
                        dynamicAnimation: {
                            enabled: true,
                            speed: 350
                        }
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                    }
                },
                dataLabels: {
                    enabled: true,
                    offsetX: -6,
                    style: {
                        fontSize: '12px',
                        colors: ['#fff']
                    }
                },
                stroke: {
                    show: true,
                    width: 1,
                    colors: ['#fff']
                },
                tooltip: {
                    shared: true,
                    intersect: false
                },
                xaxis: {
                    categories: []
                },
            },
            series: [],
            path: []
        }
    },
    mounted() {
        DashboardService.getWidgetData({ type: "Garden" }).then(res => {
            console.log(res.data.GardenServiceChart)
          
            this.setChartData(res.data.GardenServiceChart)
            // const data={
            //     series: [{
            //   data: [400, 430, 448, 470, 540, 580, 690, 1100, 1200, 1380]
            //   },
            //   {
            //   data: [400, 430, 448, 470, 540, 580, 690, 1100, 1200, 1380]
            //   }],
            //   categories: ['South Korea', 'Canada', 'United Kingdom', 'Netherlands', 'Italy', 'France', 'Japan',
            //     'United States', 'China', 'Germany'
            //   ],
            // }
          
        })
    }
   
}
</script>

<style scoped></style>